import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(pages)/protocol/page.tsx");
